import { render } from "./Game.vue?vue&type=template&id=105f7fcc"
const script = {}

import "./Game.vue?vue&type=style&index=0&id=105f7fcc&scss=true&lang=css"

import exportComponent from "D:\\job\\guobao\\guobao-ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__